import React from 'react';
import BaseAnimation from 'client/components/base-animation';
import ChannelCover from 'client/components/common/channel-cover';

const INACTIVE_OPACITY = 0.2;

export default class ChannelListItem extends BaseAnimation {
  constructor(props) {
    super(props);

    this.state = {
      positionX: props.positionX,
      opacity: props.active ? 1.0 : INACTIVE_OPACITY,
    };
  }

  static get propTypes() {
    return {
      positionX: React.PropTypes.number.isRequired,
      positionY: React.PropTypes.number.isRequired,
      active: React.PropTypes.bool.isRequired,
    };
  }

  componentWillReceiveProps(newProps) {
    this.animate('positionX', newProps.positionX, 400, 'easeInOut');
    this.animate(
      'opacity',
      newProps.active ? 1.0 : INACTIVE_OPACITY,
      400,
      'easeInOut'
    );
  }

  render() {
    let containerStyle = this.addTranslationStyle(
      this.state.positionX,
      this.props.positionY,
      {
        opacity: this.state.opacity,
      }
    );

    return (
      <div className={this.css()} style={containerStyle}>
        <div className="position copy-content">{this.props.position}</div>
        <div className="cover">
          <ChannelCover model={this.props.model} />
        </div>
        <div className="name">{this.props.model.name}</div>
        <div className="author">{this.props.model.author}</div>
        <div className="subtitle">{this.props.model.subtitle}</div>
      </div>
    );
  }
}

/*
	These should be added later...

	<div className="followers">{this.props.model.followers} Followers</div>
*/



// WEBPACK FOOTER //
// ./client/components/common/channel-list/channel-list-item/channel-list-item.es6